import { PALETTE } from '../../../constants';

export default {
  root: {
    marginTop: -60,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  }
};
